import { filterPredicateIsTruthy } from 'utility/Check/filterPredicateIsTruthy';

import { HotelCategoryFilter } from 'types/Search/filter';

const categoryMin4 = new Set([
    HotelCategoryFilter.Four,
    HotelCategoryFilter.Five,
]);
const categoryMin3 = new Set([HotelCategoryFilter.Three, ...categoryMin4]);
const categoryMin2 = new Set([HotelCategoryFilter.Two, ...categoryMin3]);
const categoryMin1 = new Set([HotelCategoryFilter.One, ...categoryMin2]);

const categoryMinLogicValueMap: Record<
    HotelCategoryFilter,
    Set<HotelCategoryFilter>
> = {
    [HotelCategoryFilter.Five]: new Set([HotelCategoryFilter.Five]),
    [HotelCategoryFilter.Four]: categoryMin4,
    [HotelCategoryFilter.Three]: categoryMin3,
    [HotelCategoryFilter.Two]: categoryMin2,
    [HotelCategoryFilter.One]: categoryMin1,
};

export const getHotelCategoryMinLogicValue = (category: HotelCategoryFilter) =>
    categoryMinLogicValueMap[category];

export const buildCategoryMinLogicMetaKey = (category: HotelCategoryFilter) =>
    [...getHotelCategoryMinLogicValue(category)].join(',');

export const buildCategoryLogicUrlValue = (category: HotelCategoryFilter) =>
    [...getHotelCategoryMinLogicValue(category)]
        .filter(filterPredicateIsTruthy)
        .join(',');

export const isCategorySelected = (
    category: HotelCategoryFilter,
    currentState: Set<HotelCategoryFilter>
) => currentState.has(category) && [...currentState][0] === category;
